import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import TaskShow from "./TaskShow";
import { getPreBaseRoute } from "../../../../components";
export const getTaskBasePath = () => "/app/task";
const TaskRoutes = () => (_jsx(Switch, { children: _jsx(Route, { path: getPreBaseRoute() + getTaskBasePath(), component: TaskShow }) }));
export default TaskRoutes;
